import axiosConfig from '../axiosConfig';

export default {
    // Date: 2022-03-14;
    // We use a POST request instead of a GET because the test server is adding a "/" at the end which gives us a CORS error. 

	/*
        POST     /api/v1/article/atc_codes
    */
	getByAtcCodes(atcCodes) {
		return axiosConfig.post('/article/atc_codes', { atc_codes: atcCodes });
	},

	/*
        POST     /api/v1/article/products
    */
	getByProducts(products) {
		return axiosConfig.post('/article/products', { products });
	},
};
